/**
 * A collection of default-url-parameter-names in a centralized file.
 * This is used throughout the application to set and read url-params, e.g. for searching or filtering datasets.
 *
 * The collection also helps define those values in a place, where client and server components can work with it.
 * Trying to use a client-site defined variable in a server component results in a silent error.
 */
export const UrlParam = {
  // general
  tab: 'tabState',
  page: 'page',
  sortBy: 'sorting',
  sortOrder: 'order',
  search: 'search',
  filter: 'filter',
  country: 'country',
  new: 'new',
  estimatedFee: 'estimatedFee',
  projectManager: 'projectManager',
  portfolioManager: 'portfolioManager',
  sponsor: 'sponsor',
  hasIncreasedRisk: 'hasIncreasedRisk',
  fieldsOfActivity: 'fieldsOfActivity',
  services: 'services',
  version: 'version',
  modal: 'modal',
  sidebarTab: 'sidebarTab',
  currency: 'currency',
  office: 'office',

  from: 'from',
  to: 'to',

  // marketplace
  myListings: 'myListings',
  savedListings: 'savedListings',
  capacityTimeFilter: 'capacityTimeFilter',
  capacityStartDate: 'capacityStartDate',
  capacityLanguages: 'capacityLanguages',
  capacityCompetences: 'capacityCompetences',

  // stories
  storyTab: 'storyTab',

  // offers
  myOffers: 'myOffers',
  showAll: 'showAll',
  projectId: 'projectId',
  isEditing: 'isEditing',
  storyId: 'storyId',
  financeDateRangeFrom: 'financeDateRangeFrom',
  financeDateRangeTo: 'financeDateRangeTo',
  financeIncomingOrdersMonthFrom: 'financeIncomingOrdersMonthFrom',
  financeIncomingOrdersMonthTo: 'financeIncomingOrdersMonthTo',
  financeSearch: 'financeSearch',
  financeNodeFilter: 'financeNodeFilter',
  financeProjectManager: 'financeProjectManager',
  financePortfolioManager: 'financePortfolioManager',
  financeIncludePending: 'financeIncludePending',

  // employees
  filterDomain: 'domains',
  filterService: 'services',
  filterLanguage: 'languages',

  // projects
  folderId: 'folderId',
  sharepointDrive: 'sharepointDrive',
  noteId: 'noteId',
  edit: 'edit',
  filterBy: 'filterBy',
  storySearch: 'storySearch',

  // table
  sortId: 'sortId',
  sortDesc: 'sortDesc',
  pageIndex: 'pageIndex',
  pageSize: 'pageSize',
  columns: 'columns',

  // incidents
  personalInjury: 'personalInjury',
  propertyDamage: 'propertyDamage',
  environmentalDamage: 'environmentalDamage',
  constructionDisruption: 'constructionDisruption',
  senders: 'senders',
  incidentDateFrom: 'incidentDateFrom',
  incidentDateTo: 'incidentDateTo',

  // search
  hybrid: 'hybrid',
  searchFocus: 'focus',

  // explore
  exploreSessionId: 'sessionId',
  exploreEnvironment: 'exploreEnvironment',

  // project finance
  projectFinanceTab: 'projectFinanceTab',
  projectFinanceDateRangeFrom: 'projectFinanceDateRangeFrom',
  projectFinanceDateRangeTo: 'projectFinanceDateRangeTo',
  projectFinanceCurrency: 'projectFinanceCurrency',
  projectFinanceDisplay: 'projectFinanceDisplay',
  projectFinanceServices: 'projectFinanceServices',
  projectFinanceBookingNumbers: 'projectFinanceBookingNumbers',

  // requirement
  requirementNumber: 'requirementNumber',
  requirementTrigger: 'requirementTrigger',
  requirementAssignee: 'requirementAssignee',
  requirementStatus: 'requirementStatus',
  requirementSource: 'requirementSource',
  requirementLot: 'requirementLot',
  requirementPhase: 'requirementPhase',
  requirementType: 'requirementType',
  requirementCategory: 'requirementCategory',
  requirementJournalSearch: 'requirementJournalSearch',
} as const
